module.exports = __webpack_public_path__ + "static/media/3.b98947cf.jpg";